<template>
  <section class="bg-primary py-20 text-white [--color-focus-ring:#FFFFFF] md:py-28">
    <div class="gob-container">
      <div class="mx-auto text-center">
        <h2 class="text-gob-6 leading-[1.08] font-black tracking-gob-tightest text-balance text-white">
          Detrás de cada dato hay una historia. 
          <br>Detrás de cada decisión, una persona.
        </h2>
        <p class="mx-auto mt-6 max-w-2xl text-gob-2 leading-relaxed text-white/90">
          En un diagnóstico revisamos cómo gestiona hoy su entidad y le mostramos dónde Gob 24/7 puede generar impacto.
        </p>
        <div class="mt-10 flex justify-center">
          <GobButton to="/contacto" variante="primario" superficie="oscura">Solicitar demo</GobButton>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import GobButton from '@/components/GobButton.vue'

/**
 * HomeCierre
 * CTA final de conversión. "Sin costo" y la ficha descargable quedan fuera hasta validarlos (D-10).
 */
export default {
  name: 'HomeCierre',
  components: { GobButton }
}
</script>
